import React, { useMemo, useState, useEffect } from "react";
import AdminPage from "../AdminPage";
import { Box, Typography } from "@mui/material";
import {
  OutlookPluginProvider,
  OutlookLoggedInContent,
  OutlookDebugMenu,
  createWebAdapter,
  createMsofficeApi,
} from "@shared/msoffice";
import { apiClient } from "../../utils/apiClient";
import DobbyChat from "@shared/msoffice/components/Chat/DobbyChatComponent";

// Web chat wrapper that uses mock mode with demo data fetched from API
function WebChatComponent(props: { conversationType: string; extraParams?: { feedId?: string }; onScrollToEmail?: (emailId: string) => void }) {
  const feedId = props.extraParams?.feedId;
  const [defaultChatAnswer, setDefaultChatAnswer] = useState<{ dobbyResponse: string; sources?: any[] } | undefined>();

  useEffect(() => {
    if (!feedId) return;
    apiClient
      .get<{ dobbyResponse: string; sources?: any[] } | null>(
        `/msoffice-api/demo/outlook/default_chat_answer?shipmentId=${feedId}`
      )
      .then((data) => {
        if (data) setDefaultChatAnswer(data);
      })
      .catch((err) => console.error("Error fetching default chat answer:", err));
  }, [feedId]);

  return (
    <DobbyChat
      conversationType="shipment_question"
      extraParams={props.extraParams}
      mockMode
      defaultChatAnswer={defaultChatAnswer}
      onOpenEmail={(messageId) => {
        if (props.onScrollToEmail) {
          props.onScrollToEmail(messageId);
        }
      }}
    />
  );
}

export function MockOutlookPluginAdminPage() {
  const adapter = useMemo(
    () =>
      createWebAdapter({
        onOpenEmail: (messageId, taskName) => {
          console.log("[Admin Page] Open email:", messageId, taskName);
        },
      }),
    []
  );

  const api = useMemo(() => createMsofficeApi(apiClient), []);

  return (
    <AdminPage>
      <Box sx={{ padding: "20px" }}>
        <Typography variant="h4" gutterBottom>
          Mock Outlook Plugin
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          This page renders the shared Outlook plugin components in a web context.
          Click on email icons to see the mock "open email" behavior.
        </Typography>

        <Box
          sx={{
            border: "1px solid #ddd",
            borderRadius: 1,
            overflow: "hidden",
            maxWidth: 450,
            height: "calc(100vh - 180px)",
            bgcolor: "background.paper",
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <OutlookPluginProvider
            context="web"
            adapter={adapter}
            api={api}
            apiClient={apiClient}
            initialMockMessageId="abc"
          >
            <OutlookLoggedInContent
              DebugMenu={OutlookDebugMenu}
              ChatComponent={WebChatComponent}
            />
          </OutlookPluginProvider>
        </Box>
      </Box>
    </AdminPage>
  );
}
